import { useEffect, useState } from "react";

/**
 * Hook to check if the component is mounted on the client side
 * @returns {boolean} `true` if the component is mounted on the client side, otherwise `false`
 */
export const useIsClientOnly = () => {
  const [isClientOnly, setIsClientOnly] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    setIsClientOnly(true);
  }, []);

  return isClientOnly;
};
